module.exports = __webpack_public_path__ + "static/08edde9d-c27b-4731-a27f-d6cd9b01cd06-fce8ffdcc9092a56069ffe20ff01c315.woff";